module.exports = __webpack_public_path__ + "static/media/JUST.c8dd8ed2.webp";